import { AllowedMaterialSpec, MaterialComponentCategory } from 'api';
import { MaterialSupportedComponentList } from 'features';
import {
  AllowedMaterialSpecAutocomplete,
  BooleanSelectField,
  CountryAutocompleteField,
  MaterialCreationProcessSelectField,
  MaterialGradeAutocomplete,
  MaterialOriginAutocomplete,
  useFormContext,
  useWatch,
} from 'form';
import { Alert } from 'ui';

import { MaterialProductFormValues } from '../../pages/schema';

export const MaterialProductFormSections = () => {
  const form = useFormContext<MaterialProductFormValues>();
  const { formState, setValue } = form;
  // @ts-expect-error non_field_errors should exist
  const nonFieldError = formState.errors?.non_field_errors?.message;
  const [materialId, materialColourId] = useWatch({
    control: form.control,
    name: ['material_id', 'material_colour_id'],
  });
  const onMaterialSpecChange = (materialSpec: AllowedMaterialSpec) => {
    setValue('material_id', materialSpec.material_id);
    setValue('material_colour_id', materialSpec.colour_id ?? undefined);
  };

  return (
    <>
      {nonFieldError ? <Alert severity="error">{nonFieldError.toString()}</Alert> : null}
      <CountryAutocompleteField name="country" label="Country" required />
      <AllowedMaterialSpecAutocomplete
        name="material_spec_id"
        label="Material spec"
        required
        onSelectOption={onMaterialSpecChange}
      />
      <MaterialGradeAutocomplete name="material_grade_id" label="Material grade" required />
      <MaterialOriginAutocomplete name="material_origin_id" label="Material origin" />
      <MaterialCreationProcessSelectField data-testid="material-creation-process" />
      <BooleanSelectField label="Food grade" name="is_food_grade" withNotAvailable data-testid={'food-grade'} />
      <BooleanSelectField
        label="Contains caps and labels"
        name="has_caps_and_labels"
        withNotAvailable
        data-testid={'caps-and-labels'}
      />
      <MaterialSupportedComponentList
        materialId={materialId}
        materialColourId={materialColourId}
        name="seller_material_component_values"
        category={MaterialComponentCategory.MATERIAL_QUALITY}
        title="Seller material componenets"
        buttonText="Add seller material component"
      />
      <MaterialSupportedComponentList
        materialId={materialId}
        materialColourId={materialColourId}
        name="buyer_material_component_values"
        category={MaterialComponentCategory.MATERIAL_QUALITY}
        title="Buyer material components"
        buttonText="Add buyer material component"
      />
    </>
  );
};
